// @ts-nocheck
import * as $ from 'jquery';
import Mediator from 'Common/Mediator';
import { NotificationType } from 'Common/NotificationManager';
import { FormConfigurations } from './Models/FormConfigurations';
import { StepCart } from './Models/stepCart';

enum Step {
    User = 1,
    Organization = 2,
    AdditionalInformation = 3,
    Signing = 4,
    Validate = 5,
    Credit = 6,
    Summary = 7,
    OrganizationFetch = 8
}

export class FormApplication {
    private configuration: FormConfigurations;
    private container: JQuery;
    private loading: JQuery;
    private cart: StepCart;

    private $orgSaveButton: JQuery;
    private $registrationNumber: JQuery;
    private $phoneNumber: JQuery;
    private $phoneNumberAlt: JQuery;
    private $addAdditionalOrgAdmin: JQuery;

    constructor(private c: JQuery) {
        this.configuration = new FormConfigurations(c);
        this.loading = c.find('.loading');
        this.$orgSaveButton = c.find('#organizationStep .btn-next');
        this.$registrationNumber = c.find('#RegistrationNumber');
        this.$phoneNumber = c.find("#PhoneNumber");
        this.$phoneNumberAlt = c.find("#PhoneNumberAlt");
        this.$addAdditionalOrgAdmin = c.find("#AddAdditionalOrgAdmin");

        this.container = c;
        this.initialize();
        if (this.configuration.isLoggedIn) {
            this.saveOrganization();
        } else {
            this.showStep(Step.User);
        }
    }

    private initialize() {
        this.container.find('#SelectedCountryCode').on('change', function (e) {
            let title = $(this).find(":selected").attr('title');
            $(this).attr('title', title);
            $(this).attr('data-bs-original-title', title);
            $(this).tooltip("hide");
            $(this).tooltip("update");
            $(this).tooltip("show");
        });

        this.container.find('#saveUserButton').on('click', () => this.saveUser());

        this.$phoneNumber.on('blur', () => this.validatePhoneNumber());
        this.$phoneNumberAlt.on('blur', () => this.validatePhoneNumberAlt());
        this.$orgSaveButton.prop("disabled", true);
        this.$orgSaveButton.on('click', () => this.saveOrganization());
        this.$registrationNumber.on('change', () => this.fetchOrganization());
        this.$addAdditionalOrgAdmin.on('click', () => this.toggleAltOrganizationAdmin());
        this.container.find('#fetchOrganization').on('click', () => this.fetchOrganization());

        // Setup listener for Signicat
        window.onmessage = (event) => {
            this.saveSigning(event);
        };

        this.container.find('.error button').on('click', (e) => this.sendErrorClick(e));
        this.container.find('#creditStep .next').on('click', () => this.submitApplication());
        this.container.find('#validateSigningStep .next').on('click', () => this.showCredit());
        this.container.find('#additionalInformationStep .next').on('click', () => this.additionalInformationStepNext());
    }

    /* User information step */
    saveUser() {
        let countryCodeText = this.container.find('#SelectedCountryCode');
        let phoneNumberText = this.container.find('#PhoneNumber');
        let userInformationForm = this.container.find("#UserInformationForm");
        let firstNameText = this.container.find('#FirstName');
        let lastNameText = this.container.find('#LastName');
        let emailText = this.container.find('#Email');

        this.validatePhoneNumber();
        let phoneNumberIsValid = !phoneNumberText.hasClass('input-validation-error');

        let additionalAdminActive = this.$addAdditionalOrgAdmin.is(":checked");

        let countryCodeTextAlt = this.container.find('#SelectedCountryCodeAlt');
        let phoneNumberTextAlt = this.container.find('#PhoneNumberAlt');
        let firstNameTextAlt = this.container.find('#FirstNameAlt');
        let lastNameTextAlt = this.container.find('#LastNameAlt');
        let emailTextAlt = this.container.find('#EmailAlt');

        let duplicatePhoneNumbersErrorMessage = this.container.find('.duplicate-phone-numbers-message').html();
        let duplicateEmailAddressesErrorMessage = this.container.find('.duplicate-email-addresses-message').html();

        this.validatePhoneNumberAlt();
        let phoneNumberAltIsValid = !phoneNumberTextAlt.hasClass('input-validation-error');

        let validAltPhone = true;
        let uniquePhoneNumbers = true;
        let uniqueEmailAddresses = true;

        if (additionalAdminActive) {
            validAltPhone = phoneNumberAltIsValid;
        }

        if (phoneNumberText.val() === phoneNumberTextAlt.val()) {
            alert(duplicatePhoneNumbersErrorMessage);
            uniquePhoneNumbers = false;
        }
        else if (emailText.val() === emailTextAlt.val()) {
            alert(duplicateEmailAddressesErrorMessage);
            uniqueEmailAddresses = false;
        }

        if (!uniquePhoneNumbers || !uniqueEmailAddresses) {
            return false;
        }

        if (userInformationForm.valid() && phoneNumberIsValid && validAltPhone) {
            $('.validation-summary-errors').addClass('validation-summary-valid')
                .removeClass('validation-summary-errors')
                .empty();
            $('#userStep .error').hide();

            let url = this.configuration.step1 +
                '?email=' + encodeURIComponent(emailText.val()) +
                '&countryCode=' + countryCodeText.val() +
                '&phoneNumber=' + phoneNumberText.val() +
                '&firstName=' + firstNameText.val() +
                '&lastName=' + lastNameText.val() +
                '&emailAlt=' + (additionalAdminActive ? encodeURIComponent(emailTextAlt.val()) : "") +
                '&countryCodeAlt=' + (additionalAdminActive ? countryCodeTextAlt.val() : "") +
                '&phoneNumberAlt=' + (additionalAdminActive ? phoneNumberTextAlt.val() : "") +
                '&firstNameAlt=' + (additionalAdminActive ? firstNameTextAlt.val() : "") +
                '&lastNameAlt=' + (additionalAdminActive ? lastNameTextAlt.val() : "") +
                '&isHjhApplication=' + this.configuration.isHjhApplication;

            const application = this;

            this.saveStep(Step.User, url, function (data: StepCart) {
                application.cart = data;
                if (application.cart.validUserInformation) {
                    application.showStep(Step.Organization);
                } else {
                    application.errorOnStep(Step.User);
                }
            });
        } else if (userInformationForm.valid()) {
            $('.validation-summary-errors').addClass('validation-summary-valid')
                .removeClass('validation-summary-errors')
                .empty().append('<ul></ul>');
        }

        if (!phoneNumberIsValid) {
            if (phoneNumberText.val() !== '') {
                this.validatePhoneNumber();
                let phoneNumberErrorMessage = this.container.find('.phone-number-error-message').html();

                $('.validation-summary-valid').addClass('validation-summary-errors')
                    .removeClass('validation-summary-valid');

                this.container.find('.validation-summary-errors').find('ul')
                    .append('<li class="summary-phone-error">' + phoneNumberErrorMessage + '</li>');
            }
        }

        if (!validAltPhone) {
            if (phoneNumberTextAlt.val() !== '') {

                this.validatePhoneNumberAlt();
                let phoneNumberErrorMessage = this.container.find('.phone-number-error-message').html();

                $('.validation-summary-valid').addClass('validation-summary-errors')
                    .removeClass('validation-summary-valid');

                this.container.find('.validation-summary-errors').find('ul')
                    .append('<li class="summary-phone-error">' + phoneNumberErrorMessage + '</li>');
            }
        }

        // to prevent form to refresh
        return false;
    }

    /* Organization information step */
    getOrganizationApiUrl() {
        let url = "";
        if (this.configuration.isLoggedIn) {
            url = this.configuration.step2 + '?formId=' + this.configuration.formId + '&registrationNumber=-';
        } else {
            let registrationNumberText = this.container.find('#RegistrationNumber');
            url = this.configuration.step2 + '?formId=' + this.cart.formId + '&registrationNumber=' +
                registrationNumberText.val().split(' ').join('');
        }

        return url;
    }

    fetchOrganization() {
        let url = this.getOrganizationApiUrl();
        const application = this;
        this.saveStep(Step.OrganizationFetch, url, function (data: StepCart) {
            application.cart = data;

            let $org = $('.organization-info');
            if (data.organizationInfo) {
                $org.find('.name').text(data.organizationInfo.name)
                $org.find('.address').text(data.organizationInfo.address)
                $org.find('.postal').text(data.organizationInfo.postNumber)
                $org.find('.city').text(data.organizationInfo.city)
                $org.show();
            } else {
                $org.hide();
            }

            if (data.organizationInfo.canBeCreated) {
                application.$orgSaveButton.removeAttr("disabled");
            }

            let hjhValidation = $('.hjh-invalid-postcode');
            hjhValidation.hide();
            if(data.isHjhApplication && !data.postCodeAllowed) {
                hjhValidation.show();
                if (!application.$orgSaveButton.attr('disabled')) {
                    application.$orgSaveButton.prop("disabled", true);
                }
            }
        });
    }

    saveOrganization() {
        let url = this.getOrganizationApiUrl();

        const application = this;

        this.saveStep(Step.Organization, url, function (data: StepCart) {
            application.cart = data;

            if (application.configuration.showAdditionalInformation) {
                application.showStep(Step.AdditionalInformation);
            } else {
                application._setupSigningFrame();
                application.showStep(Step.Signing);
            }
        });
    }

    toggleAltOrganizationAdmin() {
        let $additionalOrgAdmin = $("#AdditionalOrgAdmin");
        $additionalOrgAdmin.toggle();

        let phoneNumberTextAlt = this.container.find('#PhoneNumberAlt');
        let firstNameTextAlt = this.container.find('#FirstNameAlt');
        let lastNameTextAlt = this.container.find('#LastNameAlt');
        let emailTextAlt = this.container.find('#EmailAlt');

        if (this.$addAdditionalOrgAdmin.is(":checked")) {
            phoneNumberTextAlt.prop('required', true);
            firstNameTextAlt.prop('required', true);
            lastNameTextAlt.prop('required', true);
            emailTextAlt.prop('required', true);
        }
        else {
            phoneNumberTextAlt.removeAttr('required');
            firstNameTextAlt.removeAttr('required');
            lastNameTextAlt.removeAttr('required');
            emailTextAlt.removeAttr('required');
        }
    }

    _setupSigningFrame() {
        const application = this;
        $('#signicatSigningFrame').attr('src', application.cart.signicatUrl);

        let $signers = application.container.find('.organization-representatives');
        if (application.cart.organizationInfo.shouldValidateRepresentatives) {
            $signers.find('.representatives').html(application.cart.representatives);
            $signers.show();
        } else {
            $signers.hide();
        }
    }


    /* Signing step */
    saveSigning(event) {
        const origin = event.origin;
        if (origin !== this.cart?.signicatOrigin) return;

        let data = JSON.parse(event.data);
        let type = data.type;
        let payload = data.payload;

        if (type === 'sign_success') {
            this.cart.signicatDocumentId = payload.documentId;

            let url = this.configuration.step3 + '?formId=' + this.cart.formId + '&signicatDocumentId=' +
                this.cart.signicatDocumentId;

            const application = this;

            this.saveStep(Step.Signing, url, function (data: StepCart) {
                application.cart = data;
                application.validateSigners();
            });
        }
    }

    saveHjh()  {
        let url = this.configuration.stepHJH + '?formId=' + this.cart.formId;
        const application = this;

        this.saveStep(Step.Validate, url, function (data: StepCart) {
            application.cart = data;
            $('.finished-step-6 .summary-area').text(application.cart.finishingSummary);
            $('#summaryStep').parent().addClass('complete');
            application.showStep(Step.Summary);
        });
    }

    /* Validate signers step */
    validateSigners() {
        let url = this.configuration.step4 + '?formId=' + this.cart.formId;
        const application = this;

        this.saveStep(Step.Validate, url, function (data: StepCart) {
            application.showStep(Step.Validate);
            $('#validating-signer-loading').hide();

            if (data.creditScore) {
                let $credit = $('#bisodeCreditResultsArea');
                $credit.find('.creditValue').text(data.creditScore.creditValue + " kr");
                $credit.find('.creditScoreValue').text(data.creditScore.scoreValue + "p");
            }

            // Mirror FormApiController.Step4, which skips representative validation entirely for
            // HJH applications. Without the isHjhApplication guard an HJH application from an
            // Enkeltpersonforetak never reaches saveHjh() and the form dead-ends after signing,
            // because showCreditCheck is false for HJH so there is no other way forward.
            const shouldValidateRepresentatives =
                !application.configuration.isHjhApplication &&
                (data.organizationInfo?.shouldValidateRepresentatives ?? false);

            if (!shouldValidateRepresentatives) {
                if (application.configuration.showCreditCheck) {
                    application.showStep(Step.Credit);
                    return;
                }else{
                    application.saveHjh()
                    return;
                }
            }

            if (!data.signerValidated) {
                application.errorOnStep(Step.Validate, data.finishingSummary);
                $('.button-area').hide();
            }
        });
    }

    /* Validate signers step */
    showCredit() {
        this.showStep(Step.Credit);
    }

    additionalInformationStepNext() {
        let employeeCount = this.container.find('#EmployeeCount').val();
        let distanceToNearest = this.container.find('#DistanceToNearestStop').val();
        let parkingSpots = this.container.find("#ParkingSpots").val();
        let parkingSpotsCovered = this.container.find("input:radio[name ='ParkingSpotsCovered']:checked").val();
        let cyclingPrepared = this.container.find("input:radio[name ='CyclingPrepared']:checked").val();

        let url = this.configuration.stepAdditional
            + '?formId=' + this.cart.formId
            + '&employeeCount=' + employeeCount
            + '&distanceToNearest=' +distanceToNearest
            + '&parkingSpots=' + parkingSpots
            + '&parkingSpotsCovered=' + parkingSpotsCovered
            + '&cyclingPrepared=' + cyclingPrepared;

        const application = this;

        this.saveStep(Step.AdditionalInformation, url, function (data: StepCart) {
            application.cart = data;

            if (application.cart) {
                application._setupSigningFrame();
                application.showStep(Step.Signing);
            } else {
                application.errorOnStep(Step.AdditionalInformation);
            }
        });
    }

    /* Submit application step */
    submitApplication() {
        let url = this.configuration.step5 + '?formId=' + this.cart.formId;
        const application = this;

        this.saveStep(Step.Credit, url, function (data: StepCart) {
            application.cart = data;
            $('.finished-step-6 .summary-area').text(application.cart.finishingSummary);
            $('#summaryStep').parent().addClass('complete');
            application.showStep(Step.Summary);
        });
    }

    /* Step handling */
    async saveStep(step: Step, url: string, success: Function) {
        this.showLoading(true, step);
        this.hideError(step);

        await new Promise(f => setTimeout(f, 1800));
        let application = this;
        $.ajax({
            url: url,
            type: 'POST',
            contentType: 'application/json',
            success: function (data: StepCart) {
                application.showLoading(false);
                success(data);
            },
            error: function (data) {
                application.handleError(data, step)
                application.showLoading(false);
            }
        });
    }

    showStep(step: Step) {
        let active = this.getStepContainer(step);

        $('.accordion-collapse').each(function (e) {
            $(this).slideUp();
        });
        $(active).slideDown('slow');
        $(active).parent().prevAll('.accordion-item').addClass('complete');
    }

    showLoading(show: boolean, step: Step = null) {
        if (!show) {
            // Hide all loading messages
            this.loading.slideUp();
            return;
        }

        this.loading.slideDown();
        this.loading.find('.message').each(function (index, elem) {
            $(this).removeClass('show');
        });
        if(step!=Step.AdditionalInformation) {
            this.loading.find('.' + step).addClass('show')
        }else{
            this.loading.find('.additional').addClass('show')
        }
    }

    getStepContainer(step: Step) {
        switch (step) {
            case Step.User:
                return "#userStep";
            case Step.OrganizationFetch:
            case Step.Organization:
                return "#organizationStep";
            case Step.Signing:
                return "#signingStep";
            case Step.Validate:
                return "#validateSigningStep";
            case Step.Credit:
                return "#creditStep";
            case Step.Summary:
                return "#summaryStep";
            case Step.AdditionalInformation:
                return "#additionalInformationStep"
        }
    }

    /* Error handling */
    hideError(step: Step) {
        let $activeStep = $(this.getStepContainer(step));
        $activeStep.find('.error').hide();
    }

    handleError(data, step: Step) {
        const json = data.responseJSON;
        this.showLoading(false);
        this.errorOnStep(step, json.detail);

        let message = json.Message;
        if (!message) {
            message = `${json.status} ${json.title}`;
        }
        Mediator.instance.publish('notification:show', message, NotificationType.Error, true);
    }

    errorOnStep(step: Step, message: string = null) {
        let $activeStep = $(this.getStepContainer(step));
        $activeStep.find('.error').show();
        if (message != null && message.length > 0) {
            $activeStep.find('.error .message').html(message);
        }
    }

    sendErrorClick(e) {
        e.preventDefault();
        const btn = $(e.currentTarget);
        const step = btn.attr('data-error-step');

        let countryCodeText = this.container.find('#SelectedCountryCode');
        let phoneNumberText = this.container.find('#PhoneNumber');
        let firstNameText = this.container.find('#FirstName');
        let lastNameText = this.container.find('#LastName');
        let emailText = this.container.find('#Email');

        let errorMessage = btn.parent().find('.message').text();
        let messageSent = btn.parent().find('.message-sent');
        let sendMessageIssue = btn.parent().find('.send-message-issue');
        let apiUrl = this.configuration.sendError +
            '?errorMessage=' + (errorMessage === "" ? "na" : encodeURIComponent(errorMessage)) +
            '&email=' + encodeURIComponent(emailText.val()) +
            '&countryCode=' + countryCodeText.val() +
            '&phoneNumber=' + phoneNumberText.val() +
            '&firstName=' + firstNameText.val() +
            '&lastName=' + lastNameText.val();

        $.ajax({
            url: apiUrl,
            type: 'POST',
            contentType: 'application/json',
            success(data) {
                btn.hide();
                messageSent.show();
            },
            error(data) {
                sendMessageIssue.show();
            }
        });
    }

    validatePhoneNumber() {
        const countryCodeText = this.container.find('#SelectedCountryCode');

        if (countryCodeText.val() === '+47') {
            const norwegianPhoneNumber = new RegExp('^[0-9]{8}$');

            if (!norwegianPhoneNumber.test(this.$phoneNumber.val())) {
                this.$phoneNumber.removeClass('valid').addClass('input-validation-error');
            } else {
                this.$phoneNumber.removeClass('input-validation-error').addClass('valid');
            }
        }
    }

    validatePhoneNumberAlt() {
        const countryCodeText = this.container.find('#SelectedCountryCodeAlt');

        if (countryCodeText.val() === '+47') {
            const norwegianPhoneNumber = new RegExp('^[0-9]{8}$');

            if (!norwegianPhoneNumber.test(this.$phoneNumberAlt.val())) {
                this.$phoneNumberAlt.removeClass('valid').addClass('input-validation-error');
            } else {
                this.$phoneNumberAlt.removeClass('input-validation-error').addClass('valid');
            }
        }
    }
}